import React, { useState, useEffect } from "react";
import BroadcastList from "../components/admin/BroadcastList";
import BroadcastForm from "../components/admin/BroadcastForm";
import api from "../api";

export default function AdminBroadcast() {
  const [showForm, setShowForm] = useState(false);
  const [broadcasts, setBroadcasts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setLoading(true);
    api.get("/rundmail", { params: { page, pageSize } })
      .then(res => {
        const data = res.data || {};
        setBroadcasts(data.items || []);
        setTotal(data.total || 0);
      })
      .catch(() => setError("Fehler beim Laden der Rundmails."))
      .finally(() => setLoading(false));
  }, [page, pageSize]);

  function handleCreate() {
    setShowForm(true);
    setError("");
  }
  function handleCancel() {
    setShowForm(false);
    setError("");
  }
  async function handleSend(data) {
    setLoading(true);
    setError("");
    try {
  const res = await api.post("/rundmail", data);
      // Prüfe, ob Mailversand für Empfänger fehlgeschlagen ist
      if (res.data.mailFailedRecipients && res.data.mailFailedRecipients.length > 0) {
        const failedList = res.data.mailFailedRecipients.map(f => f.email).join(', ');
        setError(`Mailversand fehlgeschlagen für: ${failedList}`);
      } else {
        setError("");
      }
      // Nach Versand zur Seite 1 wechseln und Liste neu laden
      setPage(1);
      setShowForm(false);
    } catch (e) {
      setError(e?.response?.data?.error || "Fehler beim Senden der Rundmail.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ width: '100vw', minHeight: '100vh', background: '#181818', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
      <div style={{ maxWidth: 900, width: '100%', margin: '40px auto', background: '#222', borderRadius: 16, boxShadow: '0 2px 16px #0002', padding: 0, position:'relative', left:'-120px' }}>
        <div style={{ padding: 32 }}>
          <h2 style={{ marginBottom: 24 }}>Rundmails</h2>
          {error && <div style={{ color: '#e53935', marginBottom: 16 }}>{error}</div>}
          {loading && <div style={{ color: '#888', marginBottom: 16 }}>Lade...</div>}
          {showForm ? (
            <BroadcastForm onCancel={handleCancel} onSend={handleSend} />
          ) : (
            <BroadcastList
              onCreate={handleCreate}
              broadcasts={broadcasts}
              page={page}
              pageSize={pageSize}
              total={total}
              onChangePage={setPage}
              onChangePageSize={setPageSize}
            />
          )}
        </div>
      </div>
    </div>
  );
}
